export default __webpack_public_path__ + "2a9fca36d9265024f47fc714d365dc3e.png";